import style from "./TopBar.module.css";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import clsx from "classnames";
import { useContext, useState } from "react";
import { OmitProps } from "antd/lib/transfer/ListBody";
import { Link, useNavigate } from "react-router-dom";
import CustomIcon from "components/icons/CustomIcon";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";
import { shoppingCart } from "react-icons-kit/feather/shoppingCart";
import Icon from "react-icons-kit";
import NiceModal from "@ebay/nice-modal-react";
import { AuthContext } from "providers/AuthProvider";
function TopBarItem(props) {
  const navigate = useNavigate();
  const [isSubListVisible, setSubListVisible] = useState(false);
  const { cartAmount, wishAmount } = props;
  const { userName } = useContext(AuthContext);

  const onMouseOver = () => {
    setSubListVisible(true);
  };

  const onMouseLeave = () => {
    setSubListVisible(false);
  };

  const url = props.url ? props.url : "";

  const onClick = () => {
    if (userName){
      navigate(url);
    }else{
      NiceModal.show("memberSignIn");
    }
  }

  return (
    <li className={style.column} onClick={props.onClick ? props.onClick : onClick}>
      <VerticalMiddleWrapper>
        <div
          style={{ position: 'relative' }}
          className={style.topBarItem} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
          <span>
            <Inline>
              {props.icon ? <FontAwesomeIcon color={props.color} icon={props.icon} /> : null}
              {props.image ? (
                <img className={style.topBarFlag} src={props.image} />
              ) : null}
              <p className={style.itemTitle} style={{ color: props.color }}>{props.title}</p>
              {props.children ? (
                <FontAwesomeIcon icon={isSubListVisible ? faAngleUp : faAngleDown} color={props.color} />
              ) : null}

            </Inline>
          </span>
          {props.children ? (
            <div className={clsx(style.subItemList, { [style.show]: isSubListVisible, })}>
              <div className={style.subItemWrap}>
                {props.children}
              </div>
            </div>
          ) : null}
          {/* {cartAmount && cartAmount !== 0 &&
            <div style={{
              position: 'absolute', top: '10%', right: '0',
              backgroundColor: 'red',
              width: '15px', height: '15px',
              textAlign: 'center', color: 'white', borderRadius: '7.5px', fontWeight: 'bold', fontSize: '12px',
              display: 'flex', justifyContent: 'center', alignItems: 'center'
            }}>
              <p>
                {cartAmount}
              </p>
            </div>
          }
          {wishAmount && wishAmount !== 0 &&
            <div style={{
              position: 'absolute', top: '10%', right: '0',
              backgroundColor: 'red',
              width: '15px', height: '15px',
              textAlign: 'center', color: 'white', borderRadius: '7.5px', fontWeight: 'bold', fontSize: '12px',
              display: 'flex', justifyContent: 'center', alignItems: 'center'
            }}>
              <p>
                {wishAmount}
              </p>
            </div>
          } */}
        </div>
      </VerticalMiddleWrapper>
    </li>
  );
}

export default TopBarItem;
